import { registerLocaleData } from '@angular/common';
import { bootstrapMicrofrontend } from '@rewaa/shared-lib';
import { localeAr } from '@rewaa/locale';
import { acpEnvironment } from './environments/environment';

void bootstrapMicrofrontend({
  environment: {
    production: acpEnvironment.production,
    applicationUrl: '',
    featureFlags: { enableAnalytics: false, enableBetaFeatures: false },
    enableDatadog: acpEnvironment.enableDatadog,
    datadogRum: acpEnvironment.datadogRum,
  },
  beforeBootstrap: () => registerLocaleData(localeAr),
  importAppConfig: () => import('./app/app.config'),
  importApp: () => import('./app/app'),
  resolveAppBaseHref: (locale) => (acpEnvironment.localizedBuild ? `/${locale}/` : '/'),
  logError: (msg, err) => console.error('Failed to bootstrap ACP:', err),
});
